export default __webpack_public_path__ + "static/media/logo-emblem-white.a12da128.svg";